module.exports = __webpack_public_path__ + "static/media/airplane.fc22cb30.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/airplane.svg
// module id = 1298
// module chunks = 0